import { Control, FieldPath, FieldValues } from 'react-hook-form';

import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '../ui/form';
import { Input } from '../ui/input';

interface InputFieldProps<TFieldValues extends FieldValues> {
  control: Control<TFieldValues>;
  name: FieldPath<TFieldValues>;
  placeholder: string;
  label?: string;
  disabled?: boolean;
  autoComplete?: string;
  type: 'text' | 'email' | 'password' | 'tel' | 'number';
  'data-testid'?: string;
}
const InputField = <TFieldValues extends FieldValues>(props: InputFieldProps<TFieldValues>) => {
  const {
    control,
    name,
    placeholder,
    label,
    type,
    disabled = false,
    autoComplete = 'off',
    'data-testid': dataTestId,
  } = props;
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => {
        return (
          <FormItem>
            {label && <FormLabel>{label}</FormLabel>}
            <FormControl>
              <Input
                placeholder={placeholder}
                {...field}
                autoComplete={autoComplete}
                type={type === 'number' ? 'text' : type}
                disabled={disabled}
                data-testid={dataTestId}
                onChange={
                  type === 'number'
                    ? e => {
                        const value = e.target.value;
                        const number = +value.replace(/\D/g, '');
                        field.onChange(number.toLocaleString());
                      }
                    : field.onChange
                }
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        );
      }}
    />
  );
};

export default InputField;
